import { Component, OnInit } from '@angular/core';
import { AimsCommonTableFilterType, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowUpdate } from '@aims/common-components';
import { PermissionsService } from '../../../../services/permissions/permissions.service';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { MainGridService } from 'src/app/components/maingrid/main-grid.service';
import { PscType } from '../../hrCommon';

@Component({
  selector: 'psc-type-table',
  templateUrl: './psc-type-table.component.html',
  styleUrls: ['./psc-type-table.component.css'],
  providers: [MainGridService]
})

export class PscTypeTableComponent implements OnInit {

  tablePermissions: AimsCommonTablePermissions = {
    create: false, // Set below in constructor
    update: false, // Set below in constructor
    delete: false,
  };
  initialTableElement;

  pscType: Observable<any>;
  pscTypeHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'pscType', label: 'PSC Type Status', type: 'string', validatorOrOpts: [Validators.required, Validators.maxLength(30)] },
    { key: 'hrAuditRequired', label: 'HR Audit Required?', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'wsLeadReviewRequired', label: 'Lead Review Required?', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'dmApprovalRequired', label: 'DM Approval Required?', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'pmmApprovalRequired', label: 'PMM Approval Required?', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'hrmApprovalRequired', label: 'HRM Approval Required?', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'acctReceivalRequired', label: 'Acct Receival Required?', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'itReceivalRequired', label: 'IT Receival Required?', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'canSelfService', label: 'Employee Self Service?', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'dmSelfService', label: 'DM Self Service?', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN }
  ];

  newPscType() {
    return new PscType();
  }

  constructor(
    public permissions: PermissionsService,
    public mainGridService: MainGridService<any>
  ) {
    this.tablePermissions.create = permissions.canCreate(permissions.ComponentID.HumanResourcesConfig);
    this.tablePermissions.update = permissions.canUpdate(permissions.ComponentID.HumanResourcesConfig);
    this.pscType = this.mainGridService.getAll('Hr/GetPscType', 'Hr/SavePscType');
  }

  ngOnInit(): void {
    this.initialTableElement = this.newPscType();
  }

  handleRowUpdate(update: TableRowUpdate): void {
    this.mainGridService.update(update.newRow, update.index).subscribe(update.handleSubscribe());
  }

  handleRowAdd(update: TableRowUpdate): void {
    this.mainGridService.add(update.newRow).subscribe(update.handleSubscribe());
  }

  ngOnDestroy() {
  }
}
